// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__b+eBn","left":"Virtual_left__NFUmS","wrapper":"Virtual_wrapper__t6bTH"};